import { Form } from "react-final-form"
import { makeStyles } from "@material-ui/core/styles"
import { useConfirm } from "material-ui-confirm"
import { useSelector, useDispatch } from "react-redux"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Divider from "@material-ui/core/Divider"
import get from "lodash/get"
import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"
import React, { useState, useEffect } from "react"
import useNotification from "src/features/Notification/customs"

import { fetchAddressBook, createOrder } from "../ducks"
import Card from "./Card"
import DeliveryInfo from "./DeliveryInfo"
import Remark from './Remark'
import Empty from "./Empty"
import PriceSummary from "./PriceSummary"
import SearchModal from "./SearchProduct"
import TaxReceipt from "./TaxReceipt"
import ProcessModal from "./ProcessModal"

// separated button to open search modal
const SeachButton = () => {
  const [searchOpen, setSearchOpen] = useState(false)
  const handleOpenSearch = () => {
    setSearchOpen(true)
  }
  const handleCloseSearch = () => {
    setSearchOpen(false)
  }

  return (
    <>
      <SearchModal isOpen={searchOpen} handleClose={handleCloseSearch} />
      <Button
        color="secondary"
        size="small"
        variant="contained"
        onClick={handleOpenSearch}
        disableElevation
      >
        + ADD ITEM
      </Button>
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  root: { marginTop: theme.spacing(1), marginBottom: theme.spacing(9) },
  submit: { width: "100%", borderRadius: 17, marginTop: theme.spacing(2) },
}))

// main
function CartPage(props) {
  const classes = useStyles()
  const confirm = useConfirm()
  const dispatch = useDispatch()
  const account = useSelector((state) => state.create_order.account)
  const { showError } = useNotification()

  // const data = {};

  // fetch address book when selected account
  useEffect(() => {
    if (get(account, "_id")) {
      dispatch(fetchAddressBook(get(account, "_id")))
    }
    return () => {}
  }, [dispatch, account])

  return (
    <Form
      initialValues={{
        account: get(account, "_id"),
        billing_address: get(account, "mall.billing.address._id"),
        shipping_address: get(account, "mall.shipping_address._id"),
        request_tax_invoice: false,
        supply: [],
        medicine: [],
        remark:""
      }}
      onSubmit={async (values) => {
        console.log("values:", values)
        try {
          await dispatch(createOrder(values))
          props.setStep(3)
        } catch (error) {
          showError()
        }
      }}
      mutators={{
        setShippingAddress: (args, state, utils) => {
          utils.changeValue(state, "shipping_address", () => args[0])
        },
        setBillingAddress: (args, state, utils) => {
          utils.changeValue(state, "billing_address", () => args[0])
        },
        toggleTaxActive: (args, state, utils) => {
          utils.changeValue(
            state,
            "request_tax_invoice",
            () => !state.lastFormState.values.request_tax_invoice
          )
        },
        addMedicine: (args, state, utils) => {
          utils.changeValue(state, "medicine", () => [
            ...state.lastFormState.values.medicine,
            args[0],
          ])
        },
        removeMedicine: (args, state, utils) => {
          utils.changeValue(state, "medicine", () =>
            state.lastFormState.values.medicine.filter(
              (item) => item._id !== args[0]
            )
          )
        },
        updateMedicine: (args, state, utils) => {
          utils.changeValue(state, `medicine[${args[0]}].amount`, () => args[1])
        },
        addSupply: (args, state, utils) => {
          utils.changeValue(state, "supply", () => [
            ...state.lastFormState.values.supply,
            args[0],
          ])
        },
        removeSupply: (args, state, utils) => {
          utils.changeValue(state, "supply", () =>
            state.lastFormState.values.supply.filter(
              (item) => item._id !== args[0]
            )
          )
        },
        updateSupply: (args, state, utils) => {
          utils.changeValue(state, `supply[${args[0]}].amount`, () => args[1])
        },
        updateRemark: (args, state, utils) => {
          utils.changeValue(state, "remark", () => args[0])
        },
      }}
      subscription={{ submitting: true, values: true }}
    >
      {({ values, handleSubmit, form: { mutators } }) => {
        // confirm delete dialog
        const confirmData = (search_name) => ({
          description: `Remove ${search_name} from cart?`,
          confirmationText: "REMOVE",
          cancellationText: "CANCEL",
          confirmationButtonProps: {
            color: "primary",
            variant: "contained",
            disableElevation: true,
          },
        })

        const handleUpdateMedicine = (index, _id, search_name) => (amount) => {
          if (!amount) {
            confirm(confirmData(search_name)).then(() => {
              mutators.removeMedicine(_id)
            })
          } else {
            mutators.updateMedicine(index, amount)
          }
        }

        const handleUpdateSupply = (index, _id, search_name) => (amount) => {
          if (!amount) {
            confirm(confirmData(search_name)).then(() => {
              mutators.removeSupply(_id)
            })
          } else {
            mutators.updateSupply(index, amount)
          }
        }

        // const handleUpdateRemark = (remark) => {
        //     console.log("remark:", remark)
        //     mutators.updateRemark(remark)
        // }

        return (
          <Grid container spacing={2} className={classes.root}>
            <Grid item xs={12} md={8}>
              <Box component={Paper} elevation={0} p={2}>
                {/* Med */}
                <Box
                  display={"flex"}
                  mb={3}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box fontSize="16px" fontWeight="bold">
                    Medicine ({values.medicine.length})
                  </Box>
                  <SeachButton />
                </Box>
                {values.medicine.map((item, index) => {
                  const _id = get(item, "_id")
                  const search_name = get(item, "presentation.search_name")
                  const line1 = get(item, "barcode")
                  const line2 = `${get(item, "multiplier")} ${get(
                    item,
                    "presentation.presentation_name.name"
                  )} x ${get(item, "presentation.quantity")} ${get(
                    item,
                    "presentation.presentation_unit.name"
                  )} / ${get(item, "container.name")}`
                  const line3 = !get(item, "stock_quantity")
                    ? "สินค้าพรีออเดอร์"
                    : `สินค้าพร้อมส่งจำนวน ${get(item, "stock_quantity")}`
                  return (
                    <Card
                      key={_id}
                      search_name={search_name}
                      line1={line1}
                      line2={line2}
                      line3={line3}
                      {...item}
                      type="medicine"
                      onUpdate={handleUpdateMedicine(index, _id, search_name)}
                    />
                  )
                })}
                {!values.medicine.length && <Empty />}
                {/* Supply */}
                <Box fontSize="16px" fontWeight="bold" mt={3}>
                  Supply ({values.supply.length})
                </Box>
                {values.supply.map((item, index) => {
                  const _id = get(item, "_id")
                  const search_name = get(item, "supply.search_name")
                  const line1 = get(item, "supply.description")
                  const line2 = `${get(item, "multiplier")} ${get(
                    item,
                    "container.name"
                  )}`
                  const line3 = !get(item, "stock_quantity")
                    ? "สินค้าพรีออเดอร์"
                    : `สินค้าพร้อมส่งจำนวน ${get(item, "stock_quantity")}`
                  return (
                    <Card
                      key={_id}
                      search_name={search_name}
                      line1={line1}
                      line2={line2}
                      line3={line3}
                      {...item}
                      type="supply"
                      onUpdate={handleUpdateSupply(index, _id, search_name)}
                    />
                  )
                })}
                {!values.supply.length && <Empty />}
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box component={Paper} elevation={0} p={2}>
                <Box fontSize="12px" mb={0.5}>
                  Pharmacy Name
                </Box>
                <Box fontSize="16px" fontWeight="bold" mb={3}>
                  {get(account, "mall.name")}
                </Box>
                <Remark />
                <Divider />
                <DeliveryInfo />
                <Divider />
                <TaxReceipt />
              </Box>
              <Box component={Paper} elevation={0} p={2} mt={2}>
                <PriceSummary
                  medicineCart={values.medicine}
                  supplyCart={values.supply}
                />
              </Box>
              <ProcessModal
                handleCheckout={handleSubmit}
                supply={values.supply}
                medicine={values.medicine}
                remark={values.remark}
              >
                <Button
                  className={classes.submit}
                  color="primary"
                  variant="contained"
                  disableElevation
                >
                  PLACE ORDER
                </Button>
              </ProcessModal>
            </Grid>
          </Grid>
        )
      }}
    </Form>
  )
}

export default CartPage
